import {
  Button,
  Div,
  H3,
  Modal,
  ModalIconStyle,
  P,
  PropsModal,
  RecoverIcon,
  SuccessToast,
  recoverUserById,
  reportError,
} from '@vgrubs/components';
import { User, UserRole } from 'components/src/types/user.types';
import { Dispatch, SetStateAction } from 'react';

export const UsersAndAccessRecoverModal = ({
  setLoading,
  modalIsOpen,
  closeModal,
  onSuccess,
}: PropsModal & {
  setLoading: Dispatch<SetStateAction<boolean>>;
  modalIsOpen: User | null;
  onSuccess?: () => void;
}) => {
  const user = modalIsOpen;

  async function handleRecoverUser(recoverLocations: boolean) {
    if (!user) return;
    try {
      setLoading(true);
      const { data } = await recoverUserById(user.id, recoverLocations);
      SuccessToast(data.message);
      onSuccess?.();
    } catch (error) {
      reportError(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal
      isOpen={!!modalIsOpen}
      closeModal={closeModal}
      logo={false}
      zIndex={111}
    >
      <Div $flex $justifyCenter>
        <ModalIconStyle>
          <RecoverIcon />
        </ModalIconStyle>
      </Div>
      <H3 $mb="8">Recover User?</H3>
      <P $mb="0">
        {` Are you sure you want to recover this user? ${
          user?.role === UserRole.partner
            ? 'You can recover the user and their locations or just the user.'
            : ''
        }`}
      </P>

      <Div $flex $gap="8px" $column $mt="32">
        {user?.role === UserRole.partner && (
          <Button $selected $w="100%" onClick={() => handleRecoverUser(true)}>
            Recover User and Locations
          </Button>
        )}

        <Button $selected $w="100%" onClick={() => handleRecoverUser(false)}>
          Recover User {user?.role === UserRole.partner && 'Only'}
        </Button>
        <Button $selected $gray $w="100%" onClick={() => closeModal?.()}>
          Cancel
        </Button>
      </Div>
    </Modal>
  );
};
